// Envio de arquivos no MeuFrete (PO1-2310): a mesma tela de Upload de
// Arquivos (PO1-2716) com o canal do MeuFrete — transportadora fixa do login,
// embarcador escolhido no topo.
import React from "react";

import UploadArquivosCanal from "views/Admin/UploadArquivos";
import { CANAL_MEUFRETE } from "views/Admin/UploadArquivos/canais";

export default function EnvioArquivos() {
  return <UploadArquivosCanal canal={CANAL_MEUFRETE} />;
}
